import camelize from 'camelize';
import urlJoin from 'url-join';

const normalizeAppData = data => {
  let { menuItems, ...restData } = camelize(data);
  menuItems = (menuItems || []).filter(item => !!item.isVisible).map(({ uid, label, content }) => ({
    id: uid,
    label,
    content,
  }));

  if (data.type === 'Player') {
    const { items, templateOptions, ...rest } = camelize(restData);
    const byId = items.reduce((result, item) => ({ ...result, [item.uid]: item }), {});
    const ordered = items.map(({ uid }) => uid);

    return {
      templateOptions,
      menuItems,
      project: { ...rest },
      items: { byId, ordered },
    };
  } else if (data.type === 'Website') {
    const { sections: sectionsData, templateOptions, ...rest } = camelize(restData);

    const sections = sectionsData.reduce((result, section) => {
      result.byId[section.uid] = section;
      result.ordered.push(section.uid);
      return result;
    }, { byId: {}, ordered: [] });

    const items = sectionsData.reduce((result, section) => {
      result.bySection[section.uid] = [];
      section.items.forEach(item => {
        result.bySection[section.uid].push(item.uid);
        result.byId[item.uid] = item;
      });
      return result;
    }, { bySection: {}, byId: {} });

    return {
      templateOptions,
      project: { ...rest },
      sections,
      items,
    };
  }
};

const appDataUrl = urlJoin(window.BASE_PATH || '/', 'data', 'main.json');

export const getAppData = (requestCb, successCb, failureCb) => {
  requestCb();

  fetch(appDataUrl, { credentials: 'include' })
    .then(response => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response;
    })
    .then(response => response.json())
    .then(data => normalizeAppData(data))
    .then(data => successCb(data))
    .catch(err => {
      failureCb(err);
      console.error(err);
    });
};

export const getImageByWidth = (imageList = [], minWidth) => {
  // Sort array by width from smallest to largest, then return the first
  // item width width at least equal to minWidth. If no items match,
  // return the largest available.
  const imagesSorted = [...imageList].sort((a, b) => a.width - b.width);
  const [largest] = imagesSorted.slice(-1);
  return imagesSorted.find(({ width }) => width >= minWidth) || largest;
};

export const normalizeMediaObject = (media, imgWidth = 1500, thumbnailWidth = 200) => {
  const sourceType = media.type === 'video' ? media.source : 'htmlAudio';
  const source = media.source === 'file' ? media.versions[0].url : media.metadata.sourceUrl; // TODO
  const posterFrameImg = media.previewImages && getImageByWidth(media.previewImages.posterFrame, imgWidth);
  const posterFrame = posterFrameImg && posterFrameImg.url;
  const thumbnailImg = media.previewImages && getImageByWidth(media.previewImages.horizontalThumbnail, thumbnailWidth);
  const thumbnail = thumbnailImg && thumbnailImg.url;

  return {
    id: media.uid,
    type: media.type,
    sourceType,
    source,
    title: media.name,
    description: media.longDescription,
    credit: media.credit,
    posterFrame,
    thumbnail,
    durationSeconds: media.duration,
  };
};
